import { Directive, Input, OnDestroy } from '@angular/core';
import { ControlValueAccessor, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive()
export abstract class DsAbstractControlComponent implements ControlValueAccessor, OnDestroy {
  protected readonly subscriptions: Subscription = new Subscription();

  /** Placeholder text */
  @Input() placeholder = '';

  /** Optional label */
  @Input() label = '';

  /** HTML id attribute */
  @Input() id?: string;

  /** Optional ARIA label for accessibility */
  @Input() ariaLabel?: string;

  /** Optional ARIA labelledby for accessibility */
  @Input() ariaLabelledby?: string;

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onChange: any = () => {};

  onTouched: any = () => {};

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  /**
   * Keydown handler for the in-panel search field.
   *
   * Stops propagation so the host MatSelect's typeahead does not hijack typing, but lets Escape
   * bubble through so the overlay still closes on Esc.
   */
  onSearchKeydown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      return;
    }

    event.stopPropagation();
  }

  abstract writeValue(obj: any): void;

  abstract setDisabledState?(isDisabled: boolean): void;

  abstract get control(): FormControl;
}
